import { Button, Modal } from "antd";
import React, { Component } from "react";
// import "./modal-warning.scss";
export default class ModalCustom extends Component {
  render() {
    return (
      <Modal
        title={null}
        footer={null}
        closable={false}
        onCancel={this.props.onCancel}
        centered
        visible={this.props.visible}
        width={this.props.width}
      >
        <div className="modal">
          <div>
            {/* <div className="modal-title">
              <div className="modal-title-icon">
                <i className="fas fa-exclamation-circle" />
              </div>

              <div className="modal-title-text">{this.props.title}</div>
            </div> */}
            {this.props.children}
          </div>
        </div>
      </Modal>
    );
  }
}
